<template>
  <transition name="btm-up">
    <div class="snack-bar-overlay d-flex">
      <div class="snack-bar d-flex align-items-center mb-5">
        <span class="snack-success d-flex">
          <svg
            v-if="type == 'success'"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.5714 0.28923C11.8259 0.467387 11.8878 0.818124 11.7096 1.07262L4.66837 11.1311C4.16693 11.8509 3.17652 12.0289 2.45639 11.5277C2.3164 11.4303 2.19301 11.311 2.09095 11.1743L0.300016 8.78671C0.113604 8.53819 0.16395 8.18561 0.412467 7.9992C0.660983 7.81279 1.01356 7.86313 1.19997 8.11165L2.99216 10.5009C3.02198 10.5409 3.05807 10.5758 3.09901 10.6043C3.30937 10.7507 3.59858 10.6988 3.74497 10.4885L3.74586 10.4872L10.788 0.427458C10.9662 0.172959 11.3169 0.111072 11.5714 0.28923Z"
              fill="#06E884" />
          </svg>
        </span>
        <span class="snack-error d-flex">
          <svg
            v-if="type == 'error'"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.6477 0.352252C11.8674 0.571922 11.8674 0.928078 11.6477 1.14775L1.14775 11.6477C0.928078 11.8674 0.571922 11.8674 0.352252 11.6477C0.132583 11.4281 0.132583 11.0719 0.352252 10.8523L10.8523 0.352252C11.0719 0.132583 11.4281 0.132583 11.6477 0.352252Z"
              fill="#EC4B4B" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.352252 0.352252C0.571922 0.132583 0.928078 0.132583 1.14775 0.352252L11.6477 10.8523C11.8674 11.0719 11.8674 11.4281 11.6477 11.6477C11.4281 11.8674 11.0719 11.8674 10.8523 11.6477L0.352252 1.14775C0.132583 0.928078 0.132583 0.571922 0.352252 0.352252Z"
              fill="#EC4B4B" />
          </svg>
        </span>

        <span class="snack-loading d-flex">
          <svg
            v-if="type == 'loading'"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.625 2.22354C5.625 2.01643 5.79289 1.84854 6 1.84854C6.81585 1.84854 7.61337 2.09047 8.29173 2.54373C8.97008 2.99699 9.49879 3.64123 9.811 4.39497C10.1232 5.14872 10.2049 5.97812 10.0457 6.77829C9.88658 7.57846 9.49371 8.31347 8.91682 8.89036C8.33992 9.46725 7.60492 9.86012 6.80475 10.0193C6.00458 10.1784 5.17518 10.0968 4.42143 9.78454C3.66769 9.47233 3.02345 8.94362 2.57019 8.26527C2.11693 7.58692 1.875 6.78939 1.875 5.97354C1.875 5.76643 2.04289 5.59854 2.25 5.59854C2.45711 5.59854 2.625 5.76643 2.625 5.97354C2.625 6.64105 2.82294 7.29357 3.19379 7.84859C3.56464 8.40361 4.09174 8.83619 4.70844 9.09163C5.32514 9.34708 6.00374 9.41392 6.65843 9.28369C7.31312 9.15347 7.91448 8.83203 8.38649 8.36003C8.85849 7.88802 9.17992 7.28666 9.31015 6.63197C9.44038 5.97728 9.37354 5.29869 9.11809 4.68198C8.86265 4.06528 8.43007 3.53818 7.87505 3.16733C7.32003 2.79648 6.66751 2.59854 6 2.59854C5.79289 2.59854 5.625 2.43065 5.625 2.22354Z"
                fill="#E2E2E2" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.5568 6.89644C11.7584 6.94381 11.8835 7.14565 11.8361 7.34727C11.7117 7.87672 11.5169 8.3871 11.2569 8.86479C11.1579 9.04669 10.9302 9.11389 10.7483 9.01487C10.5664 8.91586 10.4992 8.68813 10.5982 8.50622C10.8261 8.08742 10.9969 7.63994 11.106 7.17574C11.1534 6.97413 11.3552 6.84908 11.5568 6.89644Z"
                fill="#E2E2E2" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.1784 9.75688C10.3213 9.90685 10.3155 10.1442 10.1655 10.287C9.77315 10.6607 9.33531 10.9836 8.86231 11.2479C8.68151 11.3489 8.45305 11.2842 8.35202 11.1034C8.251 10.9226 8.31566 10.6942 8.49646 10.5931C8.9145 10.3595 9.30148 10.0742 9.64825 9.74396C9.79822 9.60112 10.0356 9.60691 10.1784 9.75688Z"
                fill="#E2E2E2" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.12305 0.340444C6.14132 0.134145 6.32337 -0.0182777 6.52967 -1.75962e-06C7.07237 0.0480755 7.60588 0.170544 8.11521 0.363962C8.30883 0.437488 8.40618 0.654049 8.33266 0.847665C8.25913 1.04128 8.04257 1.13863 7.84895 1.06511C7.40389 0.896097 6.93771 0.789083 6.46349 0.747072C6.25719 0.728796 6.10477 0.546743 6.12305 0.340444Z"
                fill="#E2E2E2" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.14651 1.30411C9.27265 1.13985 9.50807 1.10894 9.67233 1.23508C10.1052 1.5675 10.4889 1.95959 10.8118 2.39965C10.9343 2.56663 10.8983 2.80131 10.7313 2.92384C10.5643 3.04636 10.3296 3.01033 10.2071 2.84335C9.9261 2.46041 9.59227 2.11921 9.21555 1.82993C9.05128 1.70379 9.02038 1.46837 9.14651 1.30411Z"
                fill="#E2E2E2" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.1719 3.74755C11.3666 3.67682 11.5817 3.77729 11.6524 3.97194C11.8392 4.48597 11.95 5.0245 11.9814 5.57051C11.9932 5.77728 11.8352 5.95452 11.6285 5.96639C11.4217 5.97826 11.2445 5.82026 11.2326 5.6135C11.2054 5.14029 11.1094 4.67356 10.9475 4.22807C10.8768 4.03341 10.9773 3.81828 11.1719 3.74755Z"
                fill="#E2E2E2" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.24229 0.38603C5.28371 0.588954 5.15278 0.787029 4.94985 0.828442C3.58529 1.10692 2.38725 1.91607 1.61928 3.07787C0.851306 4.23968 0.576312 5.65897 0.854793 7.02353C1.13327 8.38809 1.94242 9.58613 3.10422 10.3541C3.67949 10.7344 4.32402 10.9976 5.00102 11.1288C5.67802 11.2599 6.37422 11.2565 7.04988 11.1186C7.25281 11.0772 7.45088 11.2081 7.49229 11.411C7.53371 11.614 7.40278 11.812 7.19985 11.8534C6.42769 12.011 5.63205 12.015 4.85836 11.8651C4.08467 11.7152 3.34808 11.4143 2.69065 10.9798C1.36291 10.1021 0.438196 8.73295 0.11994 7.1735C-0.198315 5.61405 0.115954 3.99204 0.993614 2.6643C1.87127 1.33656 3.24043 0.411844 4.79988 0.0935887C5.00281 0.0521756 5.20088 0.183106 5.24229 0.38603Z"
                fill="#E2E2E2" />
            </g>
            <defs>
              <clipPath id="clip0">
                <path d="M0 0H12V12H0V0Z" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>

        <p class="snack-bar-message ml-1">{{ message }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GSnackBar',
  props: {
    message: String,
    type: String,
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.snack-bar-overlay {
  min-width: 220px;

  position: fixed;
  top: 0;
  z-index: 9999999999;
  left: 50%;
  transform: translate(-50%, 0px);
  .snack-bar {
    padding: 7.5px 16px;
    background: $dark3;
    margin: auto;
    margin-top: 68px;
    color: #fff;
    .snack-loading {
      animation: cog 1s infinite;
    }
    @keyframes cog {
      100% {
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
}

.btm-up-enter-active,
.btm-up-leave-active {
  transition: opacity 0.8s ease-out;
}
.btm-up-enter,
.btm-up-leave-to {
  opacity: 0;
}
.btm-up-enter-to,
.btm-up-leave {
  opacity: 1;
}
</style>
